import { z } from 'zod';
import { assetDataTypeSchema, assetTimeSchema } from '@/entities/asset/model/asset';
/**
 * 素材回收站列表项。
 *
 * 回收站接口只返回素材概要，不返回素材地址、来源、分类等主列表字段，
 * 因此这里独立建模，不复用物料主列表的 AssetItem。
 */
export const assetRecycleItemSchema = z.object({
    /** 素材 ID。 */
    id: z.number(),
    /** 素材名称。 */
    assetName: z.string(),
    /** 媒体类型编码：2-图片，3-视频，4/5-音频。 */
    assetDataType: assetDataTypeSchema,
    /** 素材封面地址；音频可能为空。 */
    coverUrl: z.string().nullable().optional(),
    /** 删除前所属项目 ID；未分类素材为空。 */
    projectId: z.number().nullable().optional(),
    /** 删除前所属项目名称；项目已不存在时为空。 */
    projectName: z.string().nullable().optional(),
    /** 删除时间。 */
    deleteTime: assetTimeSchema,
    /** 恢复截止时间，达到该时间后不可恢复。 */
    expireTime: assetTimeSchema,
    /** 按自然日向上取整的剩余可恢复天数。 */
    remainingDays: z.number().int().nonnegative(),
});
/** 素材回收站分页响应结构。 */
export const assetRecyclePageSchema = z.object({
    current: z.number(),
    size: z.number(),
    total: z.number(),
    pages: z.number(),
    records: assetRecycleItemSchema.array(),
});
/** 回收站媒体类型筛选项对应的接口媒体编码；音频兼容旧配乐编码 5。 */
export const RECYCLE_MEDIA_DATA_TYPES = {
    all: undefined,
    image: '2',
    video: '3',
    audio: '4,5',
};
/**
 * 生成剩余可恢复天数的展示文案。
 *
 * 服务端按自然日向上取整返回剩余天数，因此 0 表示当天到期；
 * 页面停留可能跨过截止点，这里只做文案降级，恢复资格以后端校验为准。
 *
 * @param remainingDays 服务端返回的剩余天数。
 * @returns 剩余天数文案。
 */
export function resolveRecycleRemainingLabel(remainingDays) {
    if (remainingDays <= 0)
        return '今日到期';
    return `剩余 ${String(remainingDays)} 天`;
}
